module.exports = __webpack_public_path__ + "img/t4.1b28da52.png";